export enum BlobTypeEnum
  {
    User = 1,
    Project = 2,
    MessageAttachments = 3,
    USComplianceDocument = 4,
    ContractAttachments = 5
  }